import { create } from "zustand";
import { apiCall } from "../../../utils/apiCall";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";

export const DashBoardStore = create((set, get) => ({
  //sats dashboard details
  SATDashboardDetails: [],
  isSATDashboardLoading: false,

  fetchSATDashboardDetails: async (Payload) => {
    set({ isSATDashboardLoading: true });
    try {
      const SATDashboardDetails = await apiCall({
        url: `${API_BASE_URL1}DashboardReport/SATCountDashboardCorpNew?Date=${Payload.startDate}&CorporationId=${Payload.corporationIds}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        SATDashboardDetails: SATDashboardDetails,
        isSATDashboardLoading: false,
        success: "SAT data fetched successfully.",
      });
    } catch (error) {
      set({
        isSATDashboardLoading: false,
        SATDashboardDetails: []
      });
    }
  },

  //scv dashboard details
  ScvDashboardDetails: [],
  isScvDashboardLoading: false,

  fetchScvDashboardDetails: async (Payload) => {
    set({ isScvDashboardLoading: true });
    try {
      const ScvDashboardDetails = await apiCall({
        url: `${API_BASE_URL1}DashboardReport/SCVCountDashboardCorpNEW?startDate=${Payload.startDate}&endDate=${Payload.endDate}&corporationId=${Payload.corporationIds}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        ScvDashboardDetails: ScvDashboardDetails,
        isScvDashboardLoading: false,
        success: "SCVs data fetched successfully.",
      });
    } catch (error) {
      set({
        isScvDashboardLoading: false,
        ScvDashboardDetails: []
      });
    }
  },



 //asset dashboard details
 AssetDashboardDetails: {} ,
 isAssetDashboardLoading: false,

 fetchAssetDashboardDetails: async (Payload) => {
   set({ isAssetDashboardLoading: true });
   try {
     const AssetDashboardDetails = await apiCall({
       url: `${API_BASE_URL1}DashboardReport/AssetDashboard`,
       
       method: "get",
       token: localStorage.getItem("token"),
     });

     set({
      AssetDashboardDetails: AssetDashboardDetails,
      isAssetDashboardLoading: false,
       success: "Assets data fetched successfully.",
     });
   } catch (error) {
     set({
      isAssetDashboardLoading: false,
      AssetDashboardDetails: {}
     });
   }
 },



  //get GVP Dashboard Details
  GvpDashboardDetails: [],
  isGvpDashboardLoading: false,
  fetchGvpDashboardDetails: async (Payload) => {
    set({ isGvpDashboardLoading: true });
    try {
      const GvpDashboardDetails = await apiCall({
        url: `${API_BASE_URL1}DashboardReport/GetGVPCountDashboardPercentage?StartDate=${Payload.startDate}&EndDate=${Payload.endDate}&CorporationId=${Payload.corporationIds}&ShiftId=${Payload.shiftId}`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({
        GvpDashboardDetails: GvpDashboardDetails,
        isGvpDashboardLoading: false,
        success: "GVPs data fetched successfully.",
      });
    } catch (error) {
      set({
        isGvpDashboardLoading: false,
        GvpDashboardDetails: []
      });
    }
  },
}));
